import { useSelector } from 'react-redux'
import {
  coachChatConversationSelector,
  mntChatConversationSelector,
  stressChatConversationSelector,
} from '@src/selectors/app'
import { CoachesCoachingKind } from '@src/types'

export const useChatConversation = (kind?: CoachesCoachingKind) => {
  const coachChatConversation = useSelector(coachChatConversationSelector)
  const mntChatConversation = useSelector(mntChatConversationSelector)
  const stressChatConversation = useSelector(stressChatConversationSelector)

  if (!kind) {
    return mntChatConversation ?? coachChatConversation
  }

  if (kind === CoachesCoachingKind.Mnt) {
    return mntChatConversation ?? coachChatConversation
  }

  return stressChatConversation
}
